import script from "./BlogTwo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogTwo.vue?vue&type=script&setup=true&lang=ts"

import "./BlogTwo.vue?vue&type=style&index=0&id=757623af&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757623af"]])

export default __exports__